import { InjectionToken } from '@angular/core';
import type { CaptchaConfig } from './captcha.interface';

export const CAPTCHA_CONFIG = new InjectionToken<CaptchaConfig>(
  'CaptchaConfig',
);
